import { Controller } from '@hotwired/stimulus'

// Embed card: the layout and position pickers copy the picked pill's tag (rendered by
// EventFormsHelper) into the mount snippet and its copy buttons. A button previews in a plain frame
// here; a side tab or floating button in its real spot, with only a Close pill left here. The
// preview modal keeps showing the form on the page (owner 2026-09-16).
export default class extends Controller {
  static targets = ['layout', 'positions', 'position', 'mount', 'mountCopy', 'preview',
    'launcherPreview', 'launcherStage']

  choose(event) {
    const pill = event.currentTarget
    this.layout = pill.dataset.layout
    this.activate(this.layoutTargets, pill)
    const group = this.positionsTargets.find((positions) => positions.dataset.layout === this.layout)
    this.positionsTargets.forEach((positions) => { positions.hidden = positions !== group })
    if (group) this.place({ currentTarget: group.querySelector('[data-position]') })
    else this.apply(pill, null)
  }

  place(event) {
    const pill = event.currentTarget
    this.activate(this.positionTargets.filter((button) => pill.closest('[role="group"]').contains(button)), pill)
    this.apply(pill, pill.dataset.position)
  }

  activate(buttons, current) {
    buttons.forEach((button) => {
      const active = button === current
      button.classList.toggle('active', active)
      button.setAttribute('aria-pressed', active)
    })
  }

  apply(pill, position) {
    const snippet = pill.dataset.snippet
    this.mountTarget.value = snippet
    this.mountCopyTarget.dataset.copyToClipboardValue = snippet
    this.showLauncher(position)
  }

  // A fresh host each time: the old one's fixed trigger and dialog leave with it.
  showLauncher(position) {
    if (!this.hasLauncherPreviewTarget) return
    this.launcherStageTarget.replaceChildren()
    const source = this.hasPreviewTarget && this.previewTarget
    if (this.layout === 'inline' || !source || !window.EightyEight) {
      this.launcherPreviewTarget.hidden = true
      return
    }
    const host = document.createElement('div')
    host.setAttribute('data-88-form', source.getAttribute('data-88-form'))
    host.setAttribute('data-ef-launcher-host', '')
    host.setAttribute('style', source.getAttribute('style') || '')
    host.dataset['88Layout'] = this.layout
    if (position) host.dataset['88Position'] = position
    this.launcherStageTarget.append(host)
    this.launcherPreviewTarget.dataset.launcher = this.layout
    this.launcherPreviewTarget.hidden = false
    window.EightyEight.mount(host, { ...(source.__eightyEightOptions || {}), inheritTheme: true })
  }

  closeLauncher() {
    this.launcherStageTarget.replaceChildren()
    this.launcherPreviewTarget.hidden = true
  }
}
